import { useEffect, useState } from "react";
import internTestApi from "../../../api/serviceApi/internTestApi";

export default function InternTestResults() {
  const [attempts, setAttempts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    internTestApi
      .get("api/intern-test/admin/attempts")
      .then(res => setAttempts(res.data))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <p>Loading results...</p>;
  }

  return (
    <div>
      <h1 className="text-2xl font-bold mb-2">Intern Test Results</h1>
      <p className="text-muted-foreground mb-6">
        View all candidate attempts and scores
      </p>

      {attempts.length === 0 ? (
        <p>No attempts found.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full border rounded-md">
            <thead className="bg-muted">
              <tr>
                <th className="text-left px-4 py-2 border">Name</th>
                <th className="text-left px-4 py-2 border">Email</th>
                <th className="text-left px-4 py-2 border">College</th>
                <th className="text-left px-4 py-2 border">Score</th>
                <th className="text-left px-4 py-2 border">Status</th>
              </tr>
            </thead>
            <tbody>
              {attempts.map(a => (
                <tr key={a._id} className="hover:bg-muted/50">
                  <td className="px-4 py-2 border">{a.name}</td>
                  <td className="px-4 py-2 border">{a.email}</td>
                  <td className="px-4 py-2 border">{a.college || "-"}</td>
                  <td className="px-4 py-2 border font-medium">
                    {a.score ?? "-"}
                  </td>
                  <td className="px-4 py-2 border">
                    {a.score >= 10 ? (
                      <span className="text-green-600 font-medium">
                        Shortlisted
                      </span>
                    ) : (
                      <span className="text-red-600 font-medium">
                        Not Selected
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
